import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { currencyCode } from 'Helpers/Geo/data';
import Price from 'Containers/Utility/Price/Price';
import Saving from 'Containers/Utility/Price/Saving';

export default function BundlePrice({
  bundles,
  price,
  fullPrice,
  hideDiscount,
  bundleTemplate,
  giveaway,
  discountPercentOverride,
  payWhatYouWant,
  totalGameCount,
}) {
  if (giveaway && bundles.length > 1) {
    return false;
  }

  if (payWhatYouWant) {
    return (
      <div className="price-container">
        <div className="price">
          <FormattedMessage id="bundle-price.pay" defaultMessage="pay " />
          <Price price={price} />
          <FormattedMessage id="bundle-price.ormore" defaultMessage=" or more " />
        </div>
      </div>
    );
  }

  if (bundles.length > 1) {
    return (
      <div className="price-container">
        <div className="price">
          <FormattedMessage id="bundle-price.from" defaultMessage="From " />
          <Price price={price} />
        </div>
        {!hideDiscount && !giveaway &&
          <div className="saving-percentage">
            <div className="tiered-text">
              <FormattedMessage id="bundle-price.upto" defaultMessage="Up to" />
            </div>
            <Saving
              price={price}
              type="bundle"
              fullPrice={fullPrice}
              discountPercentOverride={discountPercentOverride}
              giveaway={giveaway}
            />
          </div>
        }
      </div>
    );
  }

  return (
    <div>
      {bundleTemplate !== 'standard_mystery' &&
        <div className="price-container">
          <div className="price">
            <Price showZero={giveaway} price={price} />&#8200;
          </div>
          {!hideDiscount && price[currencyCode] !== fullPrice[currencyCode] &&
            <div className="was-price">
              <Price price={fullPrice} />
            </div>
          }
          {!hideDiscount && price[currencyCode] !== fullPrice[currencyCode] &&
            <div className="saving-percentage">
              <Saving
                price={price}
                type="bundle"
                fullPrice={fullPrice}
                discountPercentOverride={discountPercentOverride}
                giveaway={giveaway}
              />
            </div>
          }
        </div>
      }
      {bundleTemplate === 'standard_mystery' &&
        <div className="price-container mystery-price d-block">
          <FormattedMessage
            id="bundle-price.standard-mystery"
            defaultMessage="Get {totalGameCount} games for {price}"
            values={{
              price: <Price price={price} />,
              totalGameCount,
            }}
          />
        </div>
      }
    </div>
  );
}

BundlePrice.propTypes = {
  bundles: PropTypes.arrayOf(PropTypes.shape({})),
  bundleTemplate: PropTypes.string,
  discountPercentOverride: PropTypes.number,
  fullPrice: PropTypes.shape({}).isRequired,
  giveaway: PropTypes.bool,
  hideDiscount: PropTypes.bool,
  payWhatYouWant: PropTypes.bool,
  price: PropTypes.shape({}).isRequired,
  totalGameCount: PropTypes.number,
};

BundlePrice.defaultProps = {
  bundles: [],
  bundleTemplate: 'original',
  discountPercentOverride: 0,
  giveaway: false,
  hideDiscount: false,
  payWhatYouWant: false,
  totalGameCount: 0,
};
